/**
 * FunnelChart — Funil visual com 3 etapas (Canais → Clientes → Vidas)
 */
interface FunnelStage {
  stage: string;
  value: number;
}

interface FunnelChartProps {
  data: FunnelStage[];
  title?: string;
}

const COLORS = ["#002F59", "#0D7377", "#C0FF00"];

export default function FunnelChart({ data, title }: FunnelChartProps) {
  if (!data || data.length === 0) return null;
  const maxValue = Math.max(...data.map(d => d.value), 1);

  return (
    <div>
      {title && <h3 className="text-sm font-semibold text-[#002F59] mb-4">{title}</h3>}
      <div className="space-y-3">
        {data.map((stage, i) => {
          const widthPct = Math.max(20, (stage.value / maxValue) * 100);
          return (
            <div key={i} className="flex items-center gap-3">
              <div className="w-32 text-right">
                <p className="text-xs font-medium text-muted-foreground">{stage.stage}</p>
              </div>
              <div className="flex-1 relative">
                <div
                  className="h-10 rounded-r-lg flex items-center justify-end pr-3 transition-all duration-500"
                  style={{
                    width: `${widthPct}%`,
                    backgroundColor: COLORS[i % COLORS.length],
                    minWidth: "60px",
                  }}
                >
                  <span className="text-sm font-bold text-white">
                    {stage.value.toLocaleString("pt-BR")}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
